<h3 id="header" class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="ui basic center aligned segment">
    <p>{{ modal.context.question }}</p>
    <div class="inline">
      <button
        class="ui basic primary button"
        (click)="modal.deny(undefined)"
        appMargin
        marginR="10px"
        lmsPadding
        paddingX="15px"
      >
        {{
          modal.context.closeButtonText ? modal.context.closeButtonText : "No"
        }}
      </button>
      <button
        class="ui primary button"
        (click)="modal.approve(undefined)"
        autofocus
      >
        {{ modal.context.buttonText ? modal.context.buttonText : "Yes" }}
      </button>
    </div>
  </div>
</div>
